// extracted by css-extract-rspack-plugin
export default {"cls1":"Header-cls1_Vcc","cls2":"Header-cls2_Jnz Header-cls1_Vcc"};